import './Header.scss';
import FreightsoftLogo from '../../assets/FreightsoftLogo.png';
import QRInput from '../QRInput/QRInput';
import Account from '../../api/controllers/Account/Account';
import useToken from '../../hooks/useToken/useToken';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronCircleLeft, faHomeLg } from '@fortawesome/free-solid-svg-icons';

const Header = ({ hideQR, title, leftButton, rightButton, onScan }) => {
  const { setToken } = useToken();
  const navigate = useNavigate();

  const logout = () => {
    if (confirm('Are you sure that you want to sign out of FREIGHTsoft?')) {
      Account.logOut().then(() => {
        setToken(null);
        localStorage.removeItem('user');
        navigate('/login');
      });
    }
  };

  const getButton = buttonType => {
    switch (buttonType) {
      case 'home':
        return (
          <div className="grey_button" onClick={() => navigate('/')}>
            <FontAwesomeIcon icon={faHomeLg} className="home_icon" />
            Home
          </div>
        );

      case 'back':
        return (
          <div className="grey_button" onClick={() => navigate(-1)}>
            <FontAwesomeIcon icon={faChevronCircleLeft} className="back_icon" />
            Back
          </div>
        );

      default:
        return (
          <div className="logout_button" onClick={() => logout()}>
            Log out
          </div>
        );
    }
  };

  return (
    <div className="header_container">
      {!title && !leftButton && (
        <img src={FreightsoftLogo} data-testid="freightsoft_logo" className="freightsoft_logo" />
      )}
      {leftButton && getButton(leftButton)}
      {title && (
        <div className={`header_title ${leftButton && hideQR ? 'centred' : ''}`}>{title}</div>
      )}
      {!hideQR && <QRInput onScan={onScan} />}
      {rightButton && getButton(rightButton)}
    </div>
  );
};

Header.propTypes = {
  hideQR: PropTypes.bool,
  title: PropTypes.string,
  leftButton: PropTypes.string,
  rightButton: PropTypes.string,
  onScan: PropTypes.func,
};

export default Header;
